export const CategoryTree = [
  {
    name: "Смеси строительные",
    slug: "mixes",
    children: [
      {
        name: "Стяжка и кладка",
        slug: "screed-and-masonry",
        children: [
          {
            name: "Армированная стяжка пола",
            slug: "reinforced-screed",
            children: [],
          },
          {
            name: "Монтажная смесь",
            slug: "assembly-mix",
            children: [],
          },
          {
            name: "Пескобетон М300",
            slug: "sand-concrete-m300",
            children: [],
          },
          {
            name: "Сухие смеси М150 универсальные",
            slug: "dry-mix-m150",
            children: [],
          },
          {
            name: "Кладочные и монтажные смеси",
            slug: "masonry-assembly-mixes",
            children: [],
          },
        ],
      },
      {
        name: "Наливной пол",
        slug: "self-leveling-floor",
        children: [],
      },
      {
        name: "Плиточный клей",
        slug: "tile-adhesive",
        children: [
          {
            name: "Влагостойкий",
            slug: "moisture-resistant",
            children: [],
          },
          {
            name: "Клей для плитки и камня",
            slug: "adhesive-for-tile-stone",
            children: [],
          },
        ],
      },
      {
        name: "Штукатурки",
        slug: "plasters",
        children: [
          {
            name: "Гипсовые штукатурки",
            slug: "gypsum-plasters",
            children: [
              {
                name: "Для машинного нанесения",
                slug: "machine-application",
                children: [],
              },
              {
                name: "Для потолков и стен",
                slug: "ceilings-walls",
                children: [],
              },
            ],
          },
          {
            name: "Фасадная штукатурка",
            slug: "facade-plaster",
            children: [],
          },
          {
            name: "Декоративные штукатурки",
            slug: "decorative-plasters",
            children: [
              {
                name: "Для наружной отделки",
                slug: "for-exterior",
                children: [],
              },
              {
                name: "Нанесение эффект Шуба",
                slug: "effect-shuba",
                children: [],
              },
              {
                name: "Декоративная штукатурка Короед",
                slug: "bark-beetle",
                children: [],
              },
            ],
          },
        ],
      },

      {
        name: "Шпаклевка",
        slug: "putty",
        children: [
          {
            name: "Готовые финишные шпаклевки",
            slug: "ready-finish-putty",
            children: [],
          },
          {
            name: "Сухая в мешках",
            slug: "dry-bagged-putty",
            children: [],
          },
        ],
      },
      {
        name: "Огнеупорные",
        slug: "fire-resistant",
        children: [],
      },
      {
        name: "Затирка плитки",
        slug: "tile-grout",
        children: [],
      },
      {
        name: "Добавка для смеси бетона",
        slug: "concrete-additive",
        children: [],
      },
    ],
  },
  {
    name: "Инструмент",
    slug: "instrument",
    children: [
      {
        name: "Электроинструмент",
        slug: "power-tools",
        children: [
          { name: "Бетоносмеситель", slug: "concrete-mixer", children: [] },
          { name: "Насадка бита венчики", slug: "bit-whisks", children: [] },
          {
            name: "Перфоратор SDS plus SDS max",
            slug: "rotary-hammer",
            children: [],
          },
          {
            name: "Сварочные аппараты",
            slug: "welding-machines",
            children: [],
          },
          { name: "Термопистолет, фен", slug: "heat-gun", children: [] },
          { name: "Цепные пилы", slug: "chain-saws", children: [] },
          { name: "Циркулярные пилы", slug: "circular-saws", children: [] },
          { name: "Электролобзик", slug: "jigsaw", children: [] },
          {
            name: "Миксер электрический",
            slug: "electric-mixer",
            children: [],
          },
          {
            name: "Дрель, шуруповерт",
            slug: "drill-screwdriver",
            children: [],
          },
          { name: "Болгарка УШМ", slug: "angle-grinder", children: [] },
        ],
      },
      {
        name: "Крепёж",
        slug: "fasteners",
        children: [
          { name: "Анкер болт", slug: "anchor-bolt", children: [] },
          { name: "Анкер забивной", slug: "anchor-driving", children: [] },
          { name: "Анкер клин забивной", slug: "anchor-wedge", children: [] },
          { name: "Болты, Гайки", slug: "bolts-nuts", children: [] },
          {
            name: "Гвозди",
            slug: "nails",
            children: [
              {
                name: "Гвозди для пневмопистолета",
                slug: "nails-for-nailer",
                children: [],
              },
              {
                name: "Гвозди строительные",
                slug: "construction-nails",
                children: [],
              },
              { name: "Гвозди финишные", slug: "finish-nails", children: [] },
            ],
          },
          { name: "Дюбель пластиковый", slug: "plastic-dowel", children: [] },
          { name: "Дюбель рамный", slug: "frame-dowel", children: [] },
          { name: "Дюбель-гвозди", slug: "nail-dowel", children: [] },
          { name: "Заклепки вытяжные", slug: "blind-rivets", children: [] },
          {
            name: "Крепёж для утеплителя",
            slug: "fastener-for-insulation",
            children: [],
          },
          {
            name: "Саморезы",
            slug: "self-tapping-screws",
            children: [
              {
                name: "Саморезы кровельные",
                slug: "roofing-screws",
                children: [],
              },
              { name: "Саморезы по ГВЛ", slug: "gvl-screws", children: [] },
              { name: "Саморезы по ГКЛ", slug: "gkl-screws", children: [] },
              {
                name: "Саморезы с пресс-шайбой",
                slug: "screws-with-washer",
                children: [],
              },
              { name: "Саморезы по дереву", slug: "wood-screws", children: [] },
            ],
          },
          { name: "Шайба", slug: "washer", children: [] },
          { name: "Шпилька резьбовая", slug: "threaded-rod", children: [] },
          { name: "Шуруп", slug: "screw", children: [] },
          { name: "Уголок крепежный", slug: "fastening-bracket", children: [] },
          { name: "Дюбель металлический", slug: "metal-dowel", children: [] },
        ],
      },
      {
        name: "Расходник",
        slug: "consumable",
        children: [
          {
            name: "Бур сверла перо",
            slug: "drill-bits",
            children: [
              {
                name: "Сверла по бетону",
                slug: "concrete-drill",
                children: [],
              },
              { name: "Сверла по дереву", slug: "wood-drill", children: [] },
              { name: "Сверла по металлу", slug: "metal-drill", children: [] },
              { name: "Сверло по стеклу", slug: "glass-drill", children: [] },
              { name: "Бур SDS", slug: "sds-drill", children: [] },
            ],
          },
          {
            name: "Крючки для вязки арматуры",
            slug: "rebar-hooks",
            children: [],
          },
          {
            name: "Сварочное оборудование",
            slug: "welding-equipment",
            children: [],
          },
          {
            name: "Штукатурно-малярный",
            slug: "plastering-painting",
            children: [
              {
                name: "Канцелярское лезвие",
                slug: "utility-knife",
                children: [],
              },
              {
                name: "Маркеры, карандаши",
                slug: "markers-pencils",
                children: [],
              },
              {
                name: "Правило штукатурное",
                slug: "plaster-rule",
                children: [],
              },
              { name: "Валики", slug: "rollers", children: [] },
              {
                name: "Кисточки, краскопульт",
                slug: "brushes-spray",
                children: [],
              },
              {
                name: "Удочки, ручки, ванночки",
                slug: "rods-handles-trays",
                children: [],
              },
            ],
          },
          {
            name: "Дерево, металл, бетон обработка",
            slug: "wood-metal-concrete-processing",
            children: [
              {
                name: "Коронка, круги, чашка шлифовальная",
                slug: "cutting-grinding-cups",
                children: [],
              },
              {
                name: "Наждачная бумага, абразив, терки",
                slug: "sandpaper-abrasives",
                children: [],
              },
            ],
          },
          {
            name: "Биты, насадки, адаптеры",
            slug: "bits-attachments-adapters",
            children: [],
          },
          {
            name: "Лестницы и стремянки",
            slug: "ladders-stepladders",
            children: [],
          },
        ],
      },
      {
        name: "Ручной инструмент",
        slug: "hand-tools",
        children: [
          {
            name: "Измерительный инструмент",
            slug: "measuring-tools",
            children: [
              {
                name: "Уровень",
                slug: "level",
                children: [],
              },
              {
                name: "Рулетка",
                slug: "measuring-tape",
                children: [],
              },
              {
                name: "Линейка, штангенциркуль, микрометр",
                slug: "ruler-caliper-micrometer",
                children: [],
              },
            ],
          },
          {
            name: "Инструмент для плиточника",
            slug: "tiling-tools",
            children: [],
          },
          {
            name: "Шпатель строительный",
            slug: "putty-knife",
            children: [
              {
                name: "Шпатель плоский",
                slug: "flat-putty-knife",
                children: [],
              },
              {
                name: "Шпатель зубчатый",
                slug: "notched-putty-knife",
                children: [],
              },
              {
                name: "Шпатель многофункциональный",
                slug: "multi-putty-knife",
                children: [],
              },
            ],
          },
          {
            name: "Заклепочник",
            slug: "rivet-gun",
            children: [],
          },
          {
            name: "Крепежный инструмент",
            slug: "fastening-tools",
            children: [],
          },
          {
            name: "Металлообработка",
            slug: "metalworking-tools",
            children: [],
          },
          {
            name: "Плоскогубцы, бокорезы",
            slug: "pliers-cutters",
            children: [],
          },
          {
            name: "Столярно-слесарный инструмент",
            slug: "carpentry-tools",
            children: [
              {
                name: "Ключи и наборы ключей",
                slug: "wrenches-and-sets",
                children: [],
              },
              {
                name: "Ножовки и пилы",
                slug: "handsaws-and-saws",
                children: [],
              },
              {
                name: "Отвертки и пробники",
                slug: "screwdrivers-and-testers",
                children: [],
              },
              {
                name: "Нож и ножницы",
                slug: "knife-and-scissors",
                children: [],
              },
              {
                name: "Ударный инструмент",
                slug: "impact-tools",
                children: [],
              },
            ],
          },
          {
            name: "Электромонтажный инструмент",
            slug: "electrical-tools",
            children: [],
          },
          {
            name: "Пистолет монтажный",
            slug: "construction-gun",
            children: [],
          },
        ],
      },
      {
        name: "Отрезные круги",
        slug: "cutting-discs",
        children: [
          {
            name: "Диски по дереву",
            slug: "discs-for-wood",
            children: [],
          },
          {
            name: "Диски по камню",
            slug: "discs-for-stone",
            children: [],
          },
          {
            name: "Диски по металлу",
            slug: "discs-for-metal",
            children: [],
          },
          {
            name: "Диски шлифовальные",
            slug: "grinding-discs",
            children: [],
          },
          {
            name: "Диски алмазные",
            slug: "diamond-discs",
            children: [],
          },
        ],
      },
      {
        name: "Ящики для инструментов, органайзеры",
        slug: "toolboxes-and-organizers",
        children: [],
      },
    ],
  },
  {
    name: "Общестрой",
    slug: "general",
    children: [
      {
        name: "Хозяйственные товары",
        slug: "household-goods",
        children: [
          { name: "Моющие средства", slug: "cleaning-products", children: [] },
          { name: "Мешки для мусора", slug: "trash-bags", children: [] },
          { name: "Лента и скотч", slug: "tape-and-duct-tape", children: [] },
          { name: "Садовый инструмент", slug: "garden-tools", children: [] },
          {
            name: "Средства защиты",
            slug: "protective-equipment",
            children: [
              { name: "Респиратор", slug: "respirator", children: [] },
              { name: "Спецодежда", slug: "workwear", children: [] },
            ],
          },
          { name: "Тара", slug: "containers", children: [] },
          { name: "Скобяные изделия", slug: "hardware-products", children: [] },
          {
            name: "Ветошь, канат, волокно",
            slug: "rags-rope-fiber",
            children: [],
          },
          { name: "Постельные принадлежности", slug: "bedding", children: [] },
        ],
      },
      {
        name: "Блок, кирпич",
        slug: "block-brick",
        children: [
          {
            name: "Кирпич керамический",
            slug: "ceramic-brick",
            children: [
              {
                name: "Кирпич облицовочный",
                slug: "facing-brick",
                children: [],
              },
              { name: "Кирпич рабочий", slug: "working-brick", children: [] },
            ],
          },
          {
            name: "Строительные блоки",
            slug: "construction-blocks",
            children: [],
          },
          {
            name: "Плита гипсовая ПГП",
            slug: "gypsum-panel-pgp",
            children: [],
          },
        ],
      },
      {
        name: "Гипсокартон и комплектующие",
        slug: "drywall-and-accessories",
        children: [
          {
            name: "Подвес, соединитель",
            slug: "hanger-connector",
            children: [],
          },
          {
            name: "ГВЛ Knauf влагостойкие",
            slug: "knauf-moisture-resistant-gvl",
            children: [],
          },
          { name: "Гипсокартон", slug: "drywall", children: [] },
          {
            name: "Противопожарный огнестойкий гипсокартон",
            slug: "fire-resistant-drywall",
            children: [],
          },
          {
            name: "Гипсокартон влагостойкий (ГКЛВ)",
            slug: "moisture-resistant-drywall-gklv",
            children: [],
          },
          {
            name: "Профиль для гипсокартона",
            slug: "drywall-profile",
            children: [],
          },
          {
            name: "Профиль маячковый, уголок",
            slug: "beacon-profile-corner",
            children: [],
          },
        ],
      },
      {
        name: "Листовой материал",
        slug: "sheet-material",
        children: [
          { name: "Аквапанель", slug: "aquapanel", children: [] },
          { name: "Плоский шифер", slug: "flat-slate", children: [] },
          {
            name: "Цементно-стружечные плиты (ЦСП)",
            slug: "cement-particle-board",
            children: [],
          },
        ],
      },
      {
        name: "Нерудный материал",
        slug: "non-metal-material",
        children: [
          { name: "Песок", slug: "sand", children: [] },
          {
            name: "Керамзит (керамзитовая засыпка)",
            slug: "expanded-clay",
            children: [],
          },
          { name: "Цемент", slug: "cement", children: [] },
          { name: "Щебень", slug: "gravel", children: [] },
          { name: "Гипс", slug: "gypsum", children: [] },
          {
            name: "Побелка известью, медный купорос",
            slug: "limewash-copper-sulfate",
            children: [
              {
                name: "Известь для побелки",
                slug: "whitewash-lime",
                children: [],
              },
              { name: "Медный купорос", slug: "copper-sulfate", children: [] },
            ],
          },
        ],
      },
      {
        name: "Серпянка, стеклохолст",
        slug: "mesh-and-fiberglass",
        children: [
          { name: "Серпянка", slug: "serpyanka", children: [] },
          {
            name: "Стеклохолст, стеклообои",
            slug: "fiberglass-wallpaper",
            children: [],
          },
          {
            name: "Сетка малярная, фасадная",
            slug: "painter-facade-mesh",
            children: [],
          },
        ],
      },
      { name: "Стекловолокно, фибра", slug: "fiberglass-fiber", children: [] },
    ],
  },
  {
    name: "Лакокрасочные материалы",
    slug: "paints",
    children: [
      {
        name: "Пена монтажная",
        slug: "mounting-foam",
        children: [],
      },
      {
        name: "Краска и эмаль",
        slug: "paint-and-enamel",
        children: [
          {
            name: "Краски и эмали Tikkurila",
            slug: "paints-enamels-tikkurila",
            children: [],
          },
          {
            name: "Краски и эмали Dulux",
            slug: "paints-enamels-dulux",
            children: [],
          },
          {
            name: "Краски и эмали Finncolor",
            slug: "paints-enamels-finncolor",
            children: [],
          },
          {
            name: "Краски и эмали Hammerite",
            slug: "paints-enamels-hammerite",
            children: [],
          },
          {
            name: "Краски и эмали Текс",
            slug: "paints-enamels-tex",
            children: [],
          },
          {
            name: "Краски и эмали Farbox",
            slug: "paints-enamels-farbox",
            children: [],
          },
          {
            name: "Краски и эмали Zlata",
            slug: "paints-enamels-zlata",
            children: [],
          },
          {
            name: "Краски и эмали Мастер-Класс",
            slug: "paints-enamels-master-class",
            children: [],
          },
          {
            name: "Краски и эмали Снежинка",
            slug: "paints-enamels-snezhinka",
            children: [],
          },
          {
            name: "Краски и эмали Ареал+",
            slug: "paints-enamels-areal-plus",
            children: [],
          },
          {
            name: "Аэрозольная краска TYTAN",
            slug: "aerosol-paint-tytan",
            children: [],
          },

          {
            name: "Аэрозольная краска Empils",
            slug: "aerosol-paint-empils",
            children: [],
          },
        ],
      },

      {
        name: "Грунтовки и пропитки",
        slug: "primers-and-impregnations",
        children: [
          { name: "Грунтовка по металлу", slug: "metal-primer", children: [] },
          {
            name: "Грунтовка для штукатурки стен",
            slug: "plaster-wall-primer",
            children: [],
          },
          { name: "Огнебиозащита", slug: "fire-bio-protection", children: [] },
          { name: "Бетон-контакт", slug: "beton-contact", children: [] },
        ],
      },
      {
        name: "Лак и растворитель",
        slug: "varnish-and-solvent",
        children: [
          { name: "Лаки", slug: "varnishes", children: [] },
          {
            name: "Растворители и очистители",
            slug: "solvents-cleaners",
            children: [],
          },
        ],
      },
      {
        name: "Герметик",
        slug: "sealant",
        children: [],
      },
      {
        name: "Клей монтажный",
        slug: "mounting-glue",
        children: [
          { name: "Жидкие гвозди", slug: "liquid-nails", children: [] },
          { name: "Клей ПВА", slug: "pva-glue", children: [] },
          { name: "Клей для обоев", slug: "wallpaper-glue", children: [] },
          {
            name: "Клей для паркета и фанеры",
            slug: "parquet-plywood-glue",
            children: [],
          },
        ],
      },
    ],
  },
  {
    name: "Отделочные материалы",
    slug: "finishing",
    children: [
      {
        name: "Керамогранит",
        slug: "ceramic-granite",
        children: [],
      },
      {
        name: "Обои на флизелиновой основе",
        slug: "non-woven-wallpaper",
        children: [],
      },
      {
        name: "Подвесные потолки",
        slug: "suspended-ceilings",
        children: [
          {
            name: "Плита потолочная",
            slug: "ceiling-tile",
            children: [],
          },
          {
            name: "Подвесная система",
            slug: "suspension-system",
            children: [],
          },
          {
            name: "Реечный потолок",
            slug: "slatted-ceiling",
            children: [],
          },
        ],
      },
    ],
  },
  {
    name: "Инженерная сантехника",
    slug: "plumbing",
    children: [
      {
        name: "Обогревательное оборудование",
        slug: "heating-equipment",
        children: [
          {
            name: "Радиаторы отопления",
            slug: "heating-radiators",
            children: [
              {
                name: "Комплектующие для радиаторов",
                slug: "radiator-accessories",
                children: [],
              },
              {
                name: "Радиаторы алюминиевые",
                slug: "aluminum-radiators",
                children: [],
              },
              {
                name: "Радиаторы биметаллические",
                slug: "bimetallic-radiators",
                children: [],
              },
              {
                name: "Радиаторы масляные",
                slug: "oil-radiators",
                children: [],
              },
            ],
          },
          {
            name: "Тепловентилятор",
            slug: "fan-heater",
            children: [],
          },
        ],
      },
      {
        name: "Краны, фитинги, вентили",
        slug: "valves-fittings-taps",
        children: [
          {
            name: "Кран американка",
            slug: "union-ball-valve",
            children: [],
          },
          {
            name: "Краны полипропиленовые",
            slug: "polypropylene-valves",
            children: [],
          },
          {
            name: "Краны шаровые для воды",
            slug: "water-ball-valves",
            children: [],
          },
          {
            name: "Резьбовые фитинги",
            slug: "threaded-fittings",
            children: [],
          },
        ],
      },
      {
        name: "Полипропиленовые трубы фитинги",
        slug: "polypropylene-pipes-fittings",
        children: [
          {
            name: "Розетки углы установочные",
            slug: "installation-sockets-angles",
            children: [],
          },
          {
            name: "Фитинг комбинированный",
            slug: "combined-fitting",
            children: [],
          },
          {
            name: "Полипропиленовые трубы",
            slug: "polypropylene-pipes",
            children: [],
          },
          {
            name: "Полипропиленовые фитинги",
            slug: "polypropylene-fittings",
            children: [],
          },
        ],
      },
      {
        name: "Трубы",
        slug: "pipes",
        children: [
          {
            name: "ПНД",
            slug: "pnd-pipes",
            children: [],
          },
          {
            name: "Дренажные трубы",
            slug: "drainage-pipes",
            children: [],
          },
          {
            name: "Металлопластиковые трубы",
            slug: "metal-plastic-pipes",
            children: [],
          },
          {
            name: "Сшитый полиэтилен",
            slug: "cross-linked-polyethylene",
            children: [],
          },
        ],
      },
      {
        name: "Гибкая подводка",
        slug: "flexible-connection",
        children: [],
      },
      {
        name: "Канализация",
        slug: "sewerage",
        children: [
          {
            name: "Канализационная труба",
            slug: "sewer-pipe",
            children: [],
          },
          {
            name: "Отводы и тройники",
            slug: "bends-and-tees",
            children: [],
          },
        ],
      },
      {
        name: "Редукторы, фильтры, обратные клапаны и задвижки",
        slug: "reducers-filters-check-valves-and-gate-valves",
        children: [
          {
            name: "Редукторы давления",
            slug: "pressure-reducers",
            children: [],
          },
          {
            name: "Фильтры механической очистки воды",
            slug: "mechanical-water-filters",
            children: [],
          },
        ],
      },
      {
        name: "Клапаны радиаторные запорные",
        slug: "radiator-shut-off-valves",
        children: [],
      },
      {
        name: "Сантехнические люки",
        slug: "plumbing-hatches",
        children: [
          {
            name: "Сантехнический люк под покраску",
            slug: "plumbing-hatch-for-painting",
            children: [],
          },
          {
            name: "Сантехнический люк под плитку",
            slug: "plumbing-hatch-for-tiles",
            children: [],
          },
        ],
      },
      {
        name: "Вентили радиаторные ручной регулировки",
        slug: "manual-radiator-valves",
        children: [],
      },
      {
        name: "Коллекторы",
        slug: "collectors",
        children: [],
      },
      {
        name: "Предохранительные клапаны",
        slug: "safety-valves",
        children: [],
      },
    ],
  },
  {
    name: "Электротовары",
    slug: "electrogoods",
    children: [
      {
        name: "Электроустановочные элементы",
        slug: "electrical-installation-items",
        children: [],
      },
      {
        name: "Кабельная продукция",
        slug: "cable-products",
        children: [
          {
            name: "Кабели электрические ПВС",
            slug: "pvs-electrical-cables",
            children: [],
          },
          {
            name: "Кабель КГ силовой медный",
            slug: "kg-power-copper-cable",
            children: [],
          },
          {
            name: "Кабель силовой NYM медный",
            slug: "nym-power-copper-cable",
            children: [],
          },
          {
            name: "Кабель силовой ВВГнг LS медный",
            slug: "vvgng-ls-power-copper-cable",
            children: [],
          },
          {
            name: "ПВ3 провод установочный",
            slug: "pv3-installation-wire",
            children: [],
          },
          {
            name: "Слаботочные провода",
            slug: "low-current-wires",
            children: [],
          },
          {
            name: "Удлинители",
            slug: "extension-cords",
            children: [],
          },
        ],
      },
      {
        name: "Автоматы",
        slug: "circuit-breakers",
        children: [],
      },
      {
        name: "Электрические щиты, шкафы, боксы",
        slug: "electrical-panels-boxes",
        children: [],
      },
      {
        name: "Гофры и комплектующие",
        slug: "corrugated-tubes-and-accessories",
        children: [],
      },
      {
        name: "Рамки из искусственного камня",
        slug: "artificial-stone-frames",
        children: [],
      },
      {
        name: "Освещение",
        slug: "lighting",
        children: [],
      },
    ],
  },
  {
    name: "Изоляция",
    slug: "isolation",
    children: [
      {
        name: "Гидроизоляция",
        slug: "waterproofing",
        children: [
          {
            name: "Гидроизоляционные смеси",
            slug: "waterproofing-compounds",
            children: [],
          },
          {
            name: "Битум, мастика, праймер, полимерная",
            slug: "bitumen-mastic-primer-polymer",
            children: [],
          },
          {
            name: "Гидростеклоизол",
            slug: "hydroglassisol",
            children: [
              {
                name: "Гидростеклоизол Технониколь",
                slug: "hydroglassisol-technonicol",
                children: [],
              },
            ],
          },
          {
            name: "Пергамин и рубероид",
            slug: "pergamin-and-roofing-felt",
            children: [],
          },
          {
            name: "Техноэласт, унифлекс",
            slug: "technoelast-uniflex",
            children: [],
          },
          {
            name: "Гидроизоляционная лента",
            slug: "waterproofing-tape",
            children: [],
          },
        ],
      },
      {
        name: "Шумоизоляция профессиональная",
        slug: "professional-soundproofing",
        children: [
          {
            name: "Рулонная шумоизоляция",
            slug: "roll-soundproofing",
            children: [],
          },
          {
            name: "Панели звукоизоляционные",
            slug: "soundproofing-panels",
            children: [
              {
                name: "Звукоизоляционные панели RPG Basic с замком",
                slug: "soundproofing-panels-rpg-basic-lock",
                children: [],
              },
              {
                name: "Звукоизоляционные панели RPG Basic",
                slug: "soundproofing-panels-rpg-basic",
                children: [],
              },
              {
                name: "Звукоизоляционные панели RPG COMFORT",
                slug: "soundproofing-panels-rpg-comfort",
                children: [],
              },
            ],
          },
          {
            name: "Базальтовая",
            slug: "basalt",
            children: [],
          },
          {
            name: "Минеральная",
            slug: "mineral",
            children: [],
          },
          {
            name: "Плиты",
            slug: "boards",
            children: [],
          },
          {
            name: "Комплектующие для шумоизоляции",
            slug: "soundproofing-accessories",
            children: [],
          },
        ],
      },

      {
        name: "Утеплители",
        slug: "insulation-materials",
        children: [
          {
            name: "Базальтовые утеплители",
            slug: "basalt-insulation",
            children: [],
          },
          {
            name: "Минеральная вата в плитах",
            slug: "mineral-wool-boards",
            children: [],
          },
          {
            name: "Минеральная вата в рулонах",
            slug: "mineral-wool-rolls",
            children: [],
          },
          {
            name: "Экструдированный пенополистирол",
            slug: "extruded-polystyrene",
            children: [],
          },
          {
            name: "Пенопласт ПСБ",
            slug: "foam-psb",
            children: [],
          },
          {
            name: "Фольгированный утеплитель",
            slug: "foil-insulation",
            children: [],
          },
          {
            name: "Подложка под ламинат",
            slug: "laminate-underlay",
            children: [],
          },
        ],
      },

      {
        name: "Плёнка защитная",
        slug: "protective-film",
        children: [
          {
            name: "Ветрозащита и ветропароизоляция",
            slug: "wind-and-vapor-barrier",
            children: [
              {
                name: "Изоспан",
                slug: "izospan",
                children: [],
              },
              {
                name: "Ондутис",
                slug: "ondutis",
                children: [],
              },
              {
                name: "Пароизоляция и ветро-влагозащита Технониколь",
                slug: "vapor-and-moisture-barrier-technonicol",
                children: [],
              },
              {
                name: "Пленка для кровли Тайвек",
                slug: "roofing-film-tyvek",
                children: [],
              },
              {
                name: "Роквул",
                slug: "rockwool",
                children: [],
              },
              {
                name: "Скиптон",
                slug: "skipton",
                children: [],
              },
              {
                name: "Ютафол",
                slug: "jutafol",
                children: [],
              },
            ],
          },
          {
            name: "Плёнка полиэтиленовая",
            slug: "polyethylene-film",
            children: [],
          },
          {
            name: "Профилированная мембрана",
            slug: "profiled-membrane",
            children: [],
          },
          {
            name: "Геотекстиль",
            slug: "geotextile",
            children: [],
          },
        ],
      },
    ],
  },

  {
    name: "Пиломатериалы",
    slug: "lumber",
    children: [
      {
        name: "Обрезная доска",
        slug: "edged-board",
        children: [
          {
            name: "Брус",
            slug: "timber",
            children: [],
          },
          {
            name: "Брусок",
            slug: "bar",
            children: [],
          },
          {
            name: "Доска",
            slug: "board",
            children: [],
          },
        ],
      },
      {
        name: "Фанера",
        slug: "plywood",
        children: [
          {
            name: "Влагостойкая ФК",
            slug: "moisture-resistant-fk",
            children: [],
          },
          {
            name: "Ламинированная ФОФ",
            slug: "laminated-fof",
            children: [],
          },
          {
            name: "Плиты ОСБ",
            slug: "osb-boards",
            children: [],
          },
          {
            name: "Шлифованная фанера",
            slug: "sanded-plywood",
            children: [],
          },
          {
            name: "Водостойкая ФСФ",
            slug: "waterproof-fsf",
            children: [],
          },
          {
            name: "ДВП",
            slug: "hardboard",
            children: [],
          },
        ],
      },
      {
        name: "Облицовочная доска",
        slug: "cladding-board",
        children: [
          {
            name: "Вагонка",
            slug: "lining-board",
            children: [],
          },
          {
            name: "Строганная",
            slug: "planed",
            children: [],
          },
          {
            name: "Имитация бруса",
            slug: "timber-imitation",
            children: [],
          },
          {
            name: "Блок-хаус",
            slug: "block-house",
            children: [],
          },
          {
            name: "Европол",
            slug: "europol",
            children: [],
          },
          {
            name: "Подоконники",
            slug: "window-sills",
            children: [],
          },
          {
            name: "Наличник и плинтус",
            slug: "casing-and-baseboard",
            children: [],
          },
          {
            name: "Для бани",
            slug: "for-bath",
            children: [],
          },
        ],
      },
    ],
  },
  {
    name: "Металл",
    slug: "metal",
    children: [
      {
        name: "Арматура строительная",
        slug: "construction-rebar",
        children: [
          {
            name: "Арматура металлическая",
            slug: "metal-rebar",
            children: [],
          },
          {
            name: "Квадрат стальной",
            slug: "steel-square",
            children: [],
          },
          {
            name: "Двутавр (балка)",
            slug: "i-beam",
            children: [],
          },
          {
            name: "Лист стальной",
            slug: "steel-sheet",
            children: [],
          },
          {
            name: "Полоса стальная",
            slug: "steel-strip",
            children: [],
          },
          {
            name: "Профильная труба",
            slug: "profile-pipe",
            children: [],
          },
          {
            name: "Пруток",
            slug: "rod",
            children: [],
          },
          {
            name: "Уголок металлический стальной",
            slug: "steel-angle",
            children: [],
          },
          {
            name: "Швеллер",
            slug: "channel-bar",
            children: [],
          },
          {
            name: "Труба круглая",
            slug: "round-pipe",
            children: [],
          },
        ],
      },
      {
        name: "Сетка металлическая",
        slug: "metal-mesh",
        children: [
          {
            name: "Оцинкованная рулонная",
            slug: "galvanized-roll",
            children: [],
          },
          {
            name: "Просечка ЦПВС сетка",
            slug: "expanded-metal-mesh",
            children: [],
          },
          {
            name: "Сетка карта стальная",
            slug: "steel-map-mesh",
            children: [],
          },
          {
            name: "Сетка тканая штукатурная",
            slug: "woven-plaster-mesh",
            children: [],
          },
          {
            name: "Проволока",
            slug: "wire",
            children: [],
          },
          {
            name: "Сетка сварная черная в рулонах",
            slug: "black-welded-mesh-rolls",
            children: [],
          },
        ],
      },
      {
        name: "Системы ограждения",
        slug: "fencing-systems",
        children: [
          {
            name: "Секция забора 3D",
            slug: "fence-section-3d",
            children: [],
          },
          {
            name: "Столбы крепеж для секций",
            slug: "posts-and-mounts",
            children: [],
          },
          {
            name: "Ворота калитки 2-3Д",
            slug: "gates-and-wickets-2-3d",
            children: [],
          },
          {
            name: "Рабица металлическая",
            slug: "chain-link-mesh",
            children: [],
          },
          {
            name: "Сетка ПВХ рулонная",
            slug: "pvc-roll-mesh",
            children: [],
          },
        ],
      },
    ],
  },
];
